import {Injectable} from '@angular/core';
import * as componentActions from '@catdetails/actions/gui-zones';
import {Store} from '@ngrx/store';

@Injectable()
export class GuiZonesService {
  constructor(private store: Store<any>) {
  }

  setActive() {
    this.store.dispatch({
        type: componentActions.PROJECT_DETAILS_GUI_ZONES_ACTIVATE,
      },
    );
  }

  setInactive() {
    this.store.dispatch({
        type: componentActions.PROJECT_DETAILS_GUI_ZONES_DEACTIVATE,
      },
    );
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/services/gui-zones.service.ts